<template>
  <div>
    <a-form layout="inline">
      <a-form-item>
        <a-button v-permission="PERMISSIONS.TEMPLATE_CREATE" @click="createTemplate" style="margin-right: 20px; margin-bottom: 10px">创建模板</a-button>
        <a-input placeholder="请输入模板名称" v-model="form.template_name" style="width: 200px; margin-right: 20px; margin-bottom: 10px"></a-input>
        <a-select placeholder="请选择模板类型" allowClear style="width: 200px; margin-right: 20px; margin-bottom: 10px" v-model="form.type">
          <a-select-option value="text">text </a-select-option>
          <a-select-option value="markdown">markdown </a-select-option>
          <a-select-option value="html">html </a-select-option>
          <a-select-option value="action_card">action_card</a-select-option>
        </a-select>
        <a-checkbox v-model="form.myCreated" style="margin-right: 20px; margin-bottom: 10px; line-height: 32px">我创建的</a-checkbox>
        <a-button type="primary" @click="search">搜索</a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-item>
    </a-form>
    <a-table bordered :data-source="dataSource" :columns="columns" :pagination="false" :loading="loading" :rowKey="record => record.id">
      <template slot="operation" slot-scope="record">
        <div class="button-box">
          <a-button @click="showTemplate(record)">查看</a-button>
          <a-button v-permission="PERMISSIONS.TEMPLATE_UPDATE" @click="updateTemplate(record)">编辑</a-button>
          <a-popconfirm title="确认复制此模板?" ok-text="Yes" cancel-text="No" @confirm="copyTemplate(record)">
            <a-button v-permission="PERMISSIONS.TEMPLATE_CREATE">复制</a-button>
          </a-popconfirm>
          <a-popconfirm title="确认删除此模板?" ok-text="Yes" cancel-text="No" @confirm="deleteTemplate(record)">
            <a-button v-permission="PERMISSIONS.TEMPLATE_DELETE">删除</a-button>
          </a-popconfirm>
        </div>
      </template>
    </a-table>
    <div style="display: flex; justify-content: flex-end; margin-top: 10px">
      <a-pagination
        v-model="currentPage"
        :page-size-options="pageSizeOptions"
        :total="total"
        :page-size="pageSize"
        :showSizeChanger="true"
        :showQuickJumper="true"
        :show-total="total => `共 ${total} 条`"
        @change="pageChange"
        @showSizeChange="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { getTemplateList, getSingleTemplate, createTemplate, deleteTemplate } from '@/api/notice'
export default {
  data() {
    return {
      columns: [
        {
          title: '名称',
          key: 'name',
          dataIndex: 'name',
          width: '15%'
        },
        {
          title: '标题',
          key: 'title',
          dataIndex: 'title',
          width: '15%'
        },
        {
          title: '类型',
          dataIndex: 'type',
          width: '8%'
        },
        {
          title: '描述',
          dataIndex: 'description',
          width: '15%'
        },
        {
          title: '创建用户',
          dataIndex: 'create_user',
          width: '10%'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '15%'
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      form: {
        template_name: '', // 模板名称
        type: undefined, // 模板类型
        myCreated: false
      },
      dataSource: [],
      pageSizeOptions: ['20', '50', '100'],
      currentPage: 1,
      pageSize: 20,
      total: 1,
      loading: false
    }
  },
  created() {
    this.getTemplates()
  },
  methods: {
    getTemplates() {
      const params = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        name: this.form.template_name.trim(), // 携带搜索条件
        type: this.form.type
      }
      if (this.form.myCreated) {
        params.create_user = this.$store.state.user.name
      }
      this.loading = true
      getTemplateList(params)
        .then(res => {
          this.dataSource = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.dataSource = []
          this.total = 0
          this.loading = false
        })
    },
    search() {
      this.currentPage = 1
      this.pageSize = 20
      const params = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        name: this.form.template_name,
        type: this.form.type
      }
      if (this.form.myCreated) {
        params.create_user = this.$store.state.user.name
      }
      this.loading = true
      getTemplateList(params)
        .then(res => {
          this.dataSource = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.dataSource = []
          this.total = 0
          this.loading = false
        })
    },
    reset() {
      this.form = {
        template_name: '', // 模板名称
        type: undefined, // 模板类型
        myCreated: false
      }
      this.pageChange(1, 20)
    },
    pageChange(page, pageSize) {
      if (this.pageSize !== pageSize) {
        this.currentPage = 1 // 分页大小变化时重置页码
      } else {
        this.currentPage = page
      }
      this.pageSize = pageSize
      this.getTemplates()
    },
    createTemplate() {
      this.$router.push({ name: 'CreateTemplate', query: { type: 'create' } })
    },
    updateTemplate(data) {
      this.$router.push({ name: 'CreateTemplate', query: { type: 'update', id: data.id } })
    },
    showTemplate(data) {
      this.$router.push({ name: 'CreateTemplate', query: { type: 'show', id: data.id } })
    },
    copyTemplate(data) {
      getSingleTemplate(data.id).then(res => {
        const tpl = res.data
        const params = {
          name: tpl.name + '（副本）',
          type: tpl.type,
          title: tpl.title,
          description: tpl.description,
          content: tpl.content
        }
        createTemplate(null, params)
          .then(() => {
            this.$message.success('复制成功')
            this.getTemplates()
          })
          .catch(() => {
            this.$message.error('复制失败')
          })
      })
    },
    deleteTemplate(data) {
      deleteTemplate(data.id)
        .then(() => {
          this.getTemplates()
          this.$message.success('删除成功！', 2)
        })
        .catch(() => {
          this.$message.warning('删除失败！此模板正在被使用！', 2)
        })
    }
  }
}
</script>

<style scoped>
.button-box {
  display: flex;
  justify-content: space-evenly;
}

::v-deep .ant-table {
  height: calc(100vh - 300px);
  overflow: auto scroll;
}

::v-deep .ant-table .ant-table-thead {
  position: sticky;
  top: 0;
  background-color: #fff;
  /* 设置表头背景颜色 */
  z-index: 10;
  /* 设置表头层级 */
}
</style>
